'use client';

import { createContext } from 'react';

// ----------------------------------------------------------------------

/** 저장되는 설정 상태 — 초기값의 주인은 `src/components/settings/settings-config.ts` 다 */
export type SettingsState = {
  version?: string
  colorScheme?: string
  direction?: string
  contrast?: string
  navLayout?: string
  primaryColor?: string
  navColor?: string
  compactLayout?: boolean
  fontSize?: number
  fontFamily?: string
} & Record<string, unknown>

export type SettingsContextValue = {
  state: SettingsState
  setState: (patch: Partial<SettingsState>) => void
  setField: (name: keyof SettingsState, value: unknown) => void
  canReset: boolean
  onReset: () => void
  openDrawer: boolean
  onCloseDrawer: () => void
  onToggleDrawer: () => void
}

export const SettingsContext = createContext<SettingsContextValue | undefined>(undefined);
